import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';

const PinInput = ({ inputRefs, onPinChange }) => {
  const [pin, setPin] = useState(['', '', '', '', '', '']);

  const handleChange = (index, value) => {
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    if (onPinChange) {
      onPinChange(newPin.join('')); // Pass the full PIN to onPinChange
    }

    if (value !== '' && index < 5) {
      inputRefs.current[index + 1].current.focus();
    }
  };

  const handleBackspace = (index, event) => {
    if (event.key === 'Backspace' && index > 0 && pin[index] === '') {
      inputRefs.current[index - 1].current.focus();
    }
  };

  return (
    <div className="flex justify-center mb-4">
      {pin.map((value, index) => (
        <React.Fragment key={index}>
          <input
            ref={inputRefs.current[index]}
            type="password"
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleBackspace(index, e)}
            className="border border-blue-500 w-10 h-10 text-center mx-1 rounded shadow-lg shadow-blue-600"
            autoFocus={index === 0}
          />
          {index === 2 && <span className="mt-2 text-sky-500 ml-1">&ndash;</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

const ModalWithPinInput = ({ isModalOpen, toggleModal ,correctPin }) => {
  const inputRefs = useRef(Array.from({ length: 6 }).map(() => React.createRef()));
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (pin.length !== 6) {
      error('Please enter a 6-digit PIN.');
      return;
    }

    // Retrieve the authTokenUser from cookies
    const authTokenUser = Cookies.get('authTokenUser');

    if (!authTokenUser) {
      showErrorToast('Authorization token not found.');
      setError('Authorization token not found.');
      return;
    }

    // Check if the entered PIN matches the correct PIN
    if (pin === correctPin) {
        
      showSuccessToast('Screen unlocked successfully.');
      navigate('/Dashboard'); 
      toggleModal(); // Close the modal
    } else {
      showErrorToast('PIN is incorrect.');
      setError('PIN is incorrect. Please try again.');
    }
  };

  return (
    isModalOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/3">
          <div className="bg-gradient-to-r from-indigo-900 to-blue-700 text-white text-center py-4 rounded-t-lg">
            <span className="text-xl">To UnLock Screen Enter PIN</span>
          </div>
          <div className="p-4">
            <PinInput inputRefs={inputRefs} onPinChange={setPin} />
            {error && <div className="text-red-500 mt-2 text-center">{error}</div>}
          </div>
          <div className="flex justify-between p-6">
            <button
              type="button"
              className="bg-red-900 shadow-xl shadow-red-600 bg-gradient-to-r from-red-400 to-red-900 text-white text-xl py-0 px-2 rounded-md hover:from-red-900 hover:to-red-400 focus:outline-none"
              onClick={toggleModal}
            >
              Close
            </button>
            <button
              type="button"
              className="text-center text-white bg-blue-900 shadow-xl shadow-blue-600 bg-gradient-to-r from-blue-400 to-blue-900 font-semibold rounded-md px-2 py-0 text-xl hover:from-blue-900 hover:to-blue-400 border-1"
              onClick={handleSubmit}
            >
              UnLock
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalWithPinInput;
